<script>
import { parseISO, format, isValid } from 'date-fns'
import { useField } from 'vee-validate'
import { ref, computed, inject, watch } from 'vue'

export default {
  name: 'appDate',
  props: {
    className: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: [String, Number, Date],
      default: ''
    },
    isInvalid: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { value, errorMessage, handleChange } = useField(() => props.name, props.rules, {
      syncVModel: true,
      validateOnValueUpdate: false
    })

    const alreadySubmittedOnce = inject('alreadySubmittedOnce', ref(false))

    const handleChangeValidation = (selectedDate) => {
      if (selectedDate instanceof Date && !isNaN(selectedDate)) {
        const formattedDate = format(selectedDate, 'yyyy-MM-dd')
        emit('update:modelValue', formattedDate)
        handleChange(formattedDate, alreadySubmittedOnce.value)
      }
    }

    const formatDate = (input) => {
      if (typeof input === 'string' && input.includes('T')) {
        return format(parseISO(input.split('T')[0]), 'dd/MM/yyyy')
      }
      if (typeof input === 'string' && input.match(/^\d{4}-\d{2}-\d{2}$/)) {
        return format(parseISO(input), 'dd/MM/yyyy')
      }
      if (input instanceof Date && isValid(input)) {
        return format(input, 'dd/MM/yyyy')
      }
      return 'DD/MM/YYYY'
    }

    const valueInput = computed(() => formatDate(value.value))

    watch(
      () => props.modelValue,
      (newVal) => {
        if (newVal) {
          let formattedDate
          if (newVal instanceof Date || (typeof newVal === 'string' && !newVal.includes('-'))) {
            formattedDate = format(new Date(newVal), 'yyyy-MM-dd')
          } else if (typeof newVal === 'string' && newVal.includes('-')) {
            const datePart = newVal.includes('T') ? newVal.split('T')[0] : newVal
            formattedDate = format(parseISO(datePart), 'yyyy-MM-dd')
          }
          emit('update:modelValue', formattedDate)
        }
      },
      { immediate: true }
    )

    return {
      value,
      valueInput,
      errorMessage,
      handleChangeValidation
    }
  }
}
</script>

<template>
  <div :class="className">
    <label :for="id">{{ label }}</label>
    <i v-if="icon" :class="icon"></i>
    <VDatePicker v-model="value" @dayclick="handleChangeValidation">
      <template #default="{ togglePopover }">
        <input
          :id="id"
          :name="name"
          :value="valueInput"
          type="button"
          :disabled="isDisabled"
          :class="{ invalid: isInvalid || !!errorMessage }"
          @click="togglePopover"
        />
      </template>
    </VDatePicker>
  </div>
</template>

<style lang="scss">
.vc-header {
  .vc-title,
  .vc-arrow {
    background-color: transparent;
  }
}
.vc-popover-content-wrapper {
  z-index: 999;
}
</style>
